import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const employeesRequest = createRequest(constants.employees);
export const employeesSuccess = createSuccess(constants.employees);
export const employeesFailure = createFailure(constants.employees);

export const requestEmployees = employeesRequest;

export const employeesOptionsRequest = createRequest(constants.employeesOptions);
export const employeesOptionsSuccess = createSuccess(constants.employeesOptions);
export const employeesOptionsFailure = createFailure(constants.employeesOptions);

export const requestEmployeesOptions = employeesOptionsRequest;

export const createEmployeeRequest = createRequest(constants.createEmployee);
export const createEmployeeSuccess = createSuccess(constants.createEmployee);
export const createEmployeeFailure = createFailure(constants.createEmployee);

export const createEmployee = createEmployeeRequest;

export const updateEmployeeRequest = createRequest(constants.updateEmployee);
export const updateEmployeeSuccess = createSuccess(constants.updateEmployee);
export const updateEmployeeFailure = createFailure(constants.updateEmployee);

export const updateEmployee = updateEmployeeRequest;

export const deleteEmployeeRequest = createRequest(constants.deleteEmployee);
export const deleteEmployeeSuccess = createSuccess(constants.deleteEmployee);
export const deleteEmployeeFailure = createFailure(constants.deleteEmployee);

export const deleteEmployee = deleteEmployeeRequest;

export const copyEmployeeRequest = createRequest(constants.copyEmployee);
export const copyEmployeeSuccess = createSuccess(constants.copyEmployee);
export const copyEmployeeFailure = createFailure(constants.copyEmployee);

export const copyEmployee = copyEmployeeRequest;

export const updateEmployeeFormRequest = createRequest(constants.updateEmployeeFormConst);
export const updateEmployeeFormSuccess = createSuccess(constants.updateEmployeeFormConst);
export const updateEmployeeFormFailure = createFailure(constants.updateEmployeeFormConst);

export const updateEmployeeForm = updateEmployeeFormRequest;

export const getUserRequest = createRequest(`${constants.users}_GET_USER`);
export const getUserSuccess = createSuccess(`${constants.users}_GET_USER`);
export const getUserFailure = createFailure(`${constants.users}_GET_USER`);

export const getUser = getUserRequest;

export const employeeBadgeRequest = createRequest(constants.employeeBadge);
export const employeeBadgeSuccess = createSuccess(constants.employeeBadge);
export const employeeBadgeFailure = createFailure(constants.employeeBadge);

export const requestEmployeeBadge = employeeBadgeRequest;

export const updateEmployeeBadgeRequest = createRequest(constants.updateEmployeeBadge);
export const updateEmployeeBadgeSuccess = createSuccess(constants.updateEmployeeBadge);
export const updateEmployeeBadgeFailure = createFailure(constants.updateEmployeeBadge);

export const updateEmployeeBadge = updateEmployeeBadgeRequest;

export const employeeClientEmailSettingsRequest = createRequest(constants.employeeClientEmailSettings);
export const employeeClientEmailSettingsSuccess = createSuccess(constants.employeeClientEmailSettings);
export const employeeClientEmailSettingsFailure = createFailure(constants.employeeClientEmailSettings);

export const requestClientEmailSettingsByEmployee = employeeClientEmailSettingsRequest;

export const employeeSiteEmailSettingsRequest = createRequest(constants.employeeSiteEmailSettings);
export const employeeSiteEmailSettingsSuccess = createSuccess(constants.employeeSiteEmailSettings);
export const employeeSiteEmailSettingsFailure = createFailure(constants.employeeSiteEmailSettings);

export const requestSiteEmailSettingsByEmployee = employeeSiteEmailSettingsRequest;

export const employeeMobilePatrolEmailSettingsRequest = createRequest(
  constants.employeeMobilePatrolEmailSettings
);
export const employeeMobilePatrolEmailSettingsSuccess = createSuccess(
  constants.employeeMobilePatrolEmailSettings
);
export const employeeMobilePatrolEmailSettingsFailure = createFailure(
  constants.employeeMobilePatrolEmailSettings
);

export const requestMobilePatrolEmailSettingsByEmployee = employeeMobilePatrolEmailSettingsRequest;

export const updateEmployeeClientEmailSettingsRequest = createRequest(
  constants.updateEmployeeClientEmailSettings
);
export const updateEmployeeClientEmailSettingsSuccess = createSuccess(
  constants.updateEmployeeClientEmailSettings
);
export const updateEmployeeClientEmailSettingsFailure = createFailure(
  constants.updateEmployeeClientEmailSettings
);

export const updateClientEmailSettings = updateEmployeeClientEmailSettingsRequest;

export const updateEmployeeSiteEmailSettingsRequest = createRequest(
  constants.updateEmployeeSiteEmailSettings
);
export const updateEmployeeSiteEmailSettingsSuccess = createSuccess(
  constants.updateEmployeeSiteEmailSettings
);
export const updateEmployeeSiteEmailSettingsFailure = createFailure(
  constants.updateEmployeeSiteEmailSettings
);

export const updateSiteEmailSettings = updateEmployeeSiteEmailSettingsRequest;

export const updateEmployeeMobilePatrolEmailSettingsRequest = createRequest(
  constants.updateEmployeeMobilePatrolEmailSettings
);
export const updateEmployeeMobilePatrolEmailSettingsSuccess = createSuccess(
  constants.updateEmployeeMobilePatrolEmailSettings
);
export const updateEmployeeMobilePatrolEmailSettingsFailure = createFailure(
  constants.updateEmployeeMobilePatrolEmailSettings
);

export const updateMobilePatrolEmailSettings = updateEmployeeMobilePatrolEmailSettingsRequest;
